import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';

/**
 * Focus the returned container on mount. Needed when a dialog step swaps content
 * inside an already-open dialog (Radix autofocus only runs on open). Use `tabIndex={-1}`.
 */
const useFocusOnMount = () => {
  const $ = _c(2);
  const containerRef = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      containerRef.current?.focus();
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return containerRef;
};
export default useFocusOnMount;